import { render, staticRenderFns } from "./FaceSelector.vue?vue&type=template&id=31444f2e"
import script from "./FaceSelector.vue?vue&type=script&lang=js"
export * from "./FaceSelector.vue?vue&type=script&lang=js"
import style0 from "./FaceSelector.vue?vue&type=style&index=0&id=31444f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports